



export const treeSelectedSitesGetters = {
    treeSelectedSitesFleet(state) {
        return state.treeSelectedSitesFleet
    }
};